import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';

import WordCloudView from './WordCloudView';
import WordCloudSeries from './WordCloudSeries';
import themeRiverLayout from './themeRiverLayout';
import normalLayout from './normalLayout';

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerChartView(WordCloudView);
  registers.registerSeriesModel(WordCloudSeries);
  registers.registerLayout(themeRiverLayout);
  registers.registerLayout(normalLayout);
}
